import { buildApiUrl } from '../../services/apiConfig';

const botService = {
  async generateTextToSpeech(text) {
    try {
      const response = await fetch(buildApiUrl('TTS', '/tts_normalize'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text, summ_flag: false }),
      });
      if (!response.ok) {
        throw new Error(`TTS API responded with status: ${response.status}`);
      }
      return { success: true, audioBlob: await response.blob() };
    } catch (error) {
      console.error('Error generating text-to-speech:', error);
      return { success: false, error: error.message };
    }
  },

  async playAudioBlob(blob) {
    return new Promise((resolve) => {
      try {
        const url = URL.createObjectURL(blob);
        const audio = new Audio(url);
        audio.onended = () => { URL.revokeObjectURL(url); resolve(true); };
        audio.onerror = () => { URL.revokeObjectURL(url); resolve(false); };
        audio.play().catch(() => resolve(false));
      } catch {
        resolve(false);
      }
    });
  },

  async generateBotResponse(fullTranscript) {
    try {
      const prompt = `You are an AI customer service assistant for CAP Credit Union handling a voice callback. You have seamlessly continued from the member's web chat session. Review the full transcript and generate a natural, empathetic, professional spoken response. Keep your response to 2-3 sentences maximum. Output only the spoken words — no labels, no JSON, no formatting. If you cannot resolve the issue, say you are connecting them with a senior specialist.

TRANSCRIPT:
${fullTranscript}`;

      const formData = new FormData();
      const blob = new Blob([fullTranscript], { type: 'text/plain' });
      formData.append('file', blob, 'transcript.txt');
      formData.append('prompt', prompt);

      const response = await fetch(buildApiUrl('JAMBA', '/custom-analyze'), {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error(`JAMBA responded with ${response.status}`);
      const data = await response.json();

      // JAMBA returns { answer: "..." } or { response: "..." } or { text: "..." } or { result: "..." }
      let text = data?.answer ?? data?.response ?? data?.text ?? data?.result ?? null;

      // Fallback: pick the longest string value in the object
      if (!text && data && typeof data === 'object') {
        const values = Object.values(data).filter(v => typeof v === 'string' && v.trim().length > 5);
        values.sort((a, b) => b.length - a.length);
        text = values[0] ?? null;
      }

      if (!text) throw new Error('Empty response from bot');
      return { success: true, text: text.trim() };
    } catch (error) {
      console.error('Bot response generation failed:', error);
      return { success: false, error: error.message };
    }
  },
};

export default botService;
